function dotVec3(a, b) {
  return a.x * b.x + a.y * b.y + a.z * b.z;
}

export { dotVec3 };
//# sourceMappingURL=dot-vec3.js.map
